import React, { FC } from 'react';
import styles from './modal_actions.module.scss';

export const ModalActions: FC = ({ children }) => (
  <div className={styles.container}>{children}</div>
);
